<ng-container [formGroup]="assignmentDetailForm">
  <div class="card-body">
    <h2>Assignment</h2>
    <div class="form-row">
      <div class="form-group col-12">
        <label for="assigned_to_id" class="custom_label">Project Manager *</label>
        <ng-select
          id="project_manager_id"
          [items]="project_managers"
          placeholder="Select Project Manager"
          [closeOnSelect]="true"
          formControlName="project_manager_id"
          bindLabel="{{coreService.ngSelectBindStaffLabel}}"
        >
        </ng-select>
        <app-validation-error [formGroup]="assignmentDetailForm" [controlName]="'project_manager_id'"></app-validation-error>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-12">
        <label for="assigned_to_id" class="custom_label">Assign To </label>
        <ng-select
          id="assigned_to_id"
          [items]="staffs"
          placeholder="Select Assign To"
          [closeOnSelect]="true"
          formControlName="assigned_to_id"
          bindLabel="{{coreService.ngSelectBindStaffLabel}}"
        >
        </ng-select>
        <app-validation-error [formGroup]="assignmentDetailForm" [controlName]="'assigned_to_id'"></app-validation-error>
      </div>
    </div>


    <div class="form-row">
      <div class="form-group col-12">
        <label for="estimator_id" class="custom_label">Estimator</label>
        <ng-select
          id="estimator_id"
          [items]="estimators"
          placeholder="Select Estimator"
          [closeOnSelect]="true"
          formControlName="estimator_id"
          bindLabel="{{coreService.ngSelectBindStaffLabel}}"
        >
        </ng-select>
        <app-validation-error [formGroup]="assignmentDetailForm" [controlName]="'estimator_id'"></app-validation-error>
      </div>
    </div>


    <div class="form-row">
      <div class="form-group col-12">
        <label for="sales_rep_id" class="custom_label">Sales Rep*</label>
        <ng-select
          id="sales_rep_id"
          [items]="sales_reps"
          placeholder="Select Sales Rep"
          [closeOnSelect]="true"
          formControlName="sales_rep_id"
          bindLabel="{{coreService.ngSelectBindStaffLabel}}"
        >
        </ng-select>
        <app-validation-error [formGroup]="assignmentDetailForm" [controlName]="'sales_rep_id'"></app-validation-error>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-12">
        <label for="secondary_sales_rep_id" class="custom_label">Secondary Sales Rep</label>
        <ng-select
          id="secondary_sales_rep_id"
          [items]="sales_reps"
          placeholder="Select Secondary Sales Rep"
          [closeOnSelect]="true"
          formControlName="secondary_sales_rep_id"
          bindLabel="{{coreService.ngSelectBindStaffLabel}}"
        >
        </ng-select>
        <app-validation-error [formGroup]="assignmentDetailForm" [controlName]="'secondary_sales_rep_id'"></app-validation-error>
      </div>
    </div>

  </div>
</ng-container>
